var _style, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.61,
    height: 185.61,
    viewBox: "0 0 185.61 185.61"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#012846}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 92.8 92.8)",
    cx: 92.8,
    cy: 92.8,
    fill: "#ffca05",
    r: 92.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 55.24,
    cy: 84.83,
    r: 8.79
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 130.36,
    cy: 84.83,
    r: 8.79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.67 142.76a3.62 3.62 0 01-.7-7.19l71.29-14.04a3.62 3.62 0 111.4 7.12L60.37 142.7c-.24.04-.47.06-.7.06z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODUuNjEiIGhlaWdodD0iMTg1LjYxIiB2aWV3Qm94PSIwIDAgMTg1LjYxIDE4NS42MSI+PHN0eWxlPi5zdDF7ZmlsbDojMDEyODQ2fTwvc3R5bGU+PGNpcmNsZSB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgOTIuOCA5Mi44KSIgY3g9IjkyLjgiIGN5PSI5Mi44IiBmaWxsPSIjZmZjYTA1IiByPSI5Mi44Ii8+PGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iNTUuMjQiIGN5PSI4NC44MyIgcj0iOC43OSIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjEzMC4zNiIgY3k9Ijg0LjgzIiByPSI4Ljc5Ii8+PHBhdGggY2xhc3M9InN0MSIgZD0iTTU5LjY3IDE0Mi43NmEzLjYyIDMuNjIgMCAwMS0uNy03LjE5bDcxLjI5LTE0LjA0YTMuNjIgMy42MiAwIDExMS40IDcuMTJMNjAuMzcgMTQyLjdjLS4yNC4wNC0uNDcuMDYtLjcuMDZ6Ii8+PC9zdmc+";
export { SvgNote7 as ReactComponent };